module.exports = __webpack_public_path__ + "static/img/05.fc8e85d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/05.png
// module id = f9vf
// module chunks = 1